export const localDateString = navigator.userAgent === 'en-US' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
export const localDateTimeString = `${localDateString} HH:mm`;
